import * as actions from "../actions_agent/Type";
const intialState = {
  add_todo: {},
  items: [],
  checked: {},
  list_of_rent_property: [],
  create_calendar: {},
  calendars: [],
  view_task: {},
  // hr
  list_requests: [],
  request_view: {},
};
const TodoAppReducer = (state = intialState, action) => {
  switch (action.type) {
    case actions.ADD_TODO_APP:
      return {
        ...state,
        add_todo: action.payload,
      };
    case actions.GET_LIST_TODO_APP:
      return {
        ...state,
        items: action.payload,
      };
    case actions.UPDATEING_TODO_APP_CHECKBOX:
      return {
        ...state,
      };

    case actions.DELETE_TODO_APP_CHECKBOX:
      return {
        ...state,
      };
    case actions.CREATE_TASK_CALENDAR:
      return {
        ...state,
        create_calendar: action.payload,
      };
    case actions.GET_LIST_CALENDAR_APP:
      return {
        ...state,
        calendars: action.payload,
      };
    case actions.VIEW_TASK_CALENDAR:
      return {
        ...state,
        view_task: action.payload,
      };
    //hr
    case actions.REQUEST_TRANSFER:
      return {
        ...state,
      };
    case actions.REQUEST_LEAVE:
      return {
        ...state,
      };
    case actions.REQUEST_POSTPON:
      return {
        ...state,
      };
    case actions.REQUEST_SALARY:
      return {
        ...state,
      };
    case actions.GET_REQUEST_LISTS:
      return {
        ...state,
        list_requests: action.payload,
      };
    case actions.VIEW_REQUESTS:
      return {
        ...state,
        request_view: action.payload,
      };
    case actions.SEND_HR_FORM:
      return {
        ...state,
      };
    default:
      return { ...state };
  }
};

export default TodoAppReducer;
